import React from "react"
import {Paper, Typography, Grid} from "@material-ui/core"

import {CustomerOfferTier} from "@indebted/api"

type OfferTierCardProps = {
	tier: CustomerOfferTier
	index: number
}

function OfferTierCard({tier, index}: OfferTierCardProps) {
	const formatCurrency = (cents: number, currency: string) => {
		const amount = cents / 100
		return new Intl.NumberFormat("en-US", {
			style: "currency",
			currency: currency,
		}).format(amount)
	}

	return (
		<Paper variant="outlined" style={{padding: "12px", backgroundColor: "#f5f5f5"}}>
			<Typography variant="subtitle2" gutterBottom>
				Option {index + 1} - {tier.TierType === "ONE_OFF" ? "One-Off" : "Plan"}
			</Typography>
			<Grid container spacing={2}>
				<Grid item xs={6} sm={4}>
					<Typography variant="body2" color="textSecondary">
						Discount Rate
					</Typography>
					<Typography variant="body2">{(tier.DiscountRate * 100).toFixed(0)}%</Typography>
				</Grid>
				<Grid item xs={6} sm={4}>
					<Typography variant="body2" color="textSecondary">
						Min Payment
					</Typography>
					<Typography variant="body2">{formatCurrency(tier.MinimumPaymentAmount, tier.Currency)}</Typography>
				</Grid>
				<Grid item xs={6} sm={4}>
					<Typography variant="body2" color="textSecondary">
						Time Frame
					</Typography>
					<Typography variant="body2">{tier.TimeFrameWeeks} weeks</Typography>
				</Grid>
			</Grid>
		</Paper>
	)
}

export {OfferTierCard}
